module.exports = __webpack_public_path__ + "images/Tag_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Tag_hover.png
// module id = 392
// module chunks = 0 1